import { createFileRoute } from '@tanstack/react-router';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { TenantMarketingConsentTab } from '@/components/tenants/TenantMarketingConsentTab';
import { TenantMarketingConsentConsentsTab } from '@/components/tenants/TenantMarketingConsentConsentsTab';

export const Route = createFileRoute('/dashboard/tenant/$tenantCode/marketing-consent')({
  component: MarketingConsentRoute,
});

function MarketingConsentRoute() {
  const { tenantCode } = Route.useParams();

  return (
    <div className="space-y-4">
      <Tabs defaultValue="versions">
        <TabsList>
          <TabsTrigger value="versions">Versions</TabsTrigger>
          <TabsTrigger value="consents">Consented users</TabsTrigger>
        </TabsList>
        <TabsContent value="versions" className="mt-4">
          <TenantMarketingConsentTab tenantCode={tenantCode} />
        </TabsContent>
        <TabsContent value="consents" className="mt-4">
          <TenantMarketingConsentConsentsTab tenantCode={tenantCode} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
